// Smart action chip stack — color-coded urgent tasks at the top of
// the dashboard. Each chip describes ONE action the user needs to
// take, with a vivid tone to telegraph urgency at a glance:
//
//   tone="red"    — urgent / overdue
//   tone="amber"  — pending / due soon
//   tone="blue"   — informational
//   tone="green"  — celebration / good news
//   tone="purple" — captain / leadership tasks
//
// Renders as a horizontal scrolling row on mobile, wrapping row on
// desktop. Each chip is clickable and accepts an onClick handler.

import React from "react";
import { ChevronRight } from "lucide-react";

export default function SmartActionChips({ chips }) {
  // Filter out null/undefined chip entries so callers can use the
  // conditional pattern `flag && { id, ... }` without manual filtering.
  const list = (chips || []).filter(Boolean);
  if (list.length === 0) return null;
  return (
    <div className="smartChips" role="list">
      {list.map(chip => (
        <button
          key={chip.id}
          type="button"
          role="listitem"
          className={`smartChip smartChip--${chip.tone || "blue"}`}
          onClick={chip.onClick}
          aria-label={chip.label}
        >
          {chip.icon && <span className="smartChip-ic">{chip.icon}</span>}
          <span className="smartChip-text">
            {chip.label}
            {chip.sub && <small className="smartChip-sub">{chip.sub}</small>}
          </span>
          {chip.onClick && <ChevronRight size={14} className="smartChip-arrow"/>}
        </button>
      ))}
    </div>
  );
}
